import React from 'react';
import { Card, CardContent } from '../ui/card';
import { Input } from '../ui/input';
import { Users, UserCircle, MagnifyingGlass } from '@phosphor-icons/react';

function StatusBadge({ status, STATUS_MAP }) {
  const cfg = STATUS_MAP[status] || STATUS_MAP.no_subscription;
  const Icon = cfg.icon;
  return (
    <span className={`inline-flex items-center gap-1 text-[11px] px-2 py-0.5 rounded font-bold ${cfg.color}`}
      data-testid={`status-badge-${status}`}>
      <Icon size={12} weight="fill" /> {cfg.label}
    </span>
  );
}

function MemberRow({ m, STATUS_MAP, onClick }) {
  return (
    <Card className="border hover:border-[#FF6B00]/40 transition-colors cursor-pointer"
      onClick={() => onClick(m.id)} data-testid={`member-${m.id}`}>
      <CardContent className="p-3 sm:p-4">
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-10 h-10 rounded-full bg-gray-100 flex items-center justify-center flex-shrink-0 overflow-hidden">
              {m.picture ? (
                <img src={m.picture} alt="" className="w-full h-full object-cover rounded-full" />
              ) : (
                <UserCircle size={24} className="text-gray-400" weight="fill" />
              )}
            </div>
            <div className="min-w-0">
              <div className="flex items-center gap-2 flex-wrap">
                <p className="text-sm font-bold text-[#111827] truncate">{m.name || 'Sans nom'}</p>
                <StatusBadge status={m.subscription_status} STATUS_MAP={STATUS_MAP} />
              </div>
              <p className="text-xs text-[#6B7280] truncate">{m.email}</p>
            </div>
          </div>
          <div className="text-right flex-shrink-0 hidden sm:block">
            {m.plan_name ? (
              <>
                <p className="text-xs font-bold text-[#FF6B00]">{m.plan_name}</p>
                <p className="text-[10px] text-[#9CA3AF]">{m.plan_price} EUR</p>
              </>
            ) : (
              <p className="text-[10px] text-[#9CA3AF]">-</p>
            )}
          </div>
        </div>
        <div className="flex items-center gap-4 mt-2 text-[10px] text-[#9CA3AF]">
          <span>Inscrit le {m.created_at ? new Date(m.created_at).toLocaleDateString('fr-FR') : '-'}</span>
          {m.sub_end && <span>Expire le {new Date(m.sub_end).toLocaleDateString('fr-FR')}</span>}
          {m.auto_renew && <span className="text-emerald-600 font-bold">Renouvellement auto</span>}
        </div>
      </CardContent>
    </Card>
  );
}

export function AdminMembersTab({ filteredMembers, search, setSearch, statusFilter, setStatusFilter, openMemberDetail, STATUS_MAP }) {
  return (
    <div className="space-y-3" data-testid="members-tab">
      <div className="flex flex-col sm:flex-row gap-2">
        <div className="relative flex-1">
          <MagnifyingGlass size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#9CA3AF]" />
          <Input placeholder="Rechercher par nom ou email..."
            value={search} onChange={e => setSearch(e.target.value)}
            className="pl-9 h-10" data-testid="member-search" />
        </div>
        <select value={statusFilter} onChange={e => setStatusFilter(e.target.value)}
          className="h-10 rounded-md border border-gray-200 px-3 text-xs font-medium text-[#374151] bg-white"
          data-testid="status-filter">
          <option value="all">Tous les statuts</option>
          <option value="active">Actifs</option>
          <option value="trialing">Essai payant</option>
          <option value="trial_free">Essai gratuit</option>
          <option value="grace_period">Grace</option>
          <option value="cancelled">Annules</option>
          <option value="expired">Expires</option>
          <option value="no_subscription">Aucun abonnement</option>
        </select>
      </div>

      <p className="text-xs text-[#9CA3AF]">{filteredMembers.length} membre(s) affiche(s)</p>

      {filteredMembers.length === 0 ? (
        <Card className="border border-dashed">
          <CardContent className="p-8 text-center">
            <Users size={32} className="mx-auto text-gray-300 mb-2" />
            <p className="text-sm text-[#6B7280]">Aucun membre ne correspond a vos criteres</p>
          </CardContent>
        </Card>
      ) : (
        <div className="space-y-2">
          {filteredMembers.map(m => (
            <MemberRow key={m.id} m={m} STATUS_MAP={STATUS_MAP} onClick={openMemberDetail} />
          ))}
        </div>
      )}
    </div>
  );
}
